import dayjs from 'dayjs'

export * from '../../core/analytics/AnalyticsProvider'
export * from './plugins'
import * as crypto from 'crypto'

/**
 * GoogleAnalyticsのECommerce用にtransactionIdを生成する
 * 購入ごとにユニークであれば良いため、userId/timestamp/random数 を用いてHash文字列を取得する
 * @param uid userId
 * @returns hash化された文字列
 */
export function generateTransactionId(uid?: string) {
  const md5 = crypto.createHash('md5')
  const currentTimestamp = dayjs().unix()
  const randomNumber = Math.random()
  return md5
    .update(`${uid}:${currentTimestamp}:${randomNumber}`, 'binary')
    .digest('hex')
}
